import { useComponentVariant } from '@/hooks/theme/useComponentVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import dynamic from 'next/dynamic';

const LayoutV1 = dynamic(() => import('./v1.1'), { ssr: true });
const LayoutV2 = dynamic(() => import('./v1.2'), { ssr: true });
const LayoutV3 = dynamic(() => import('./v1.3'), { ssr: true });
const LayoutV4 = dynamic(() => import('./v1.4'), { ssr: true });
const LayoutV5 = dynamic(() => import('./v3'), { ssr: true });

export function UserRankCard({
  id,
  navigation,
}: {
  id: string;
  navigation?: boolean;
}) {
  const version: string =
    useComponentVariant(ComponentTypeId.UserProfileChip) ??
    SettingLayoutComponentId.UserProfileChipV1.toString();

  switch (version?.toString()) {
    case SettingLayoutComponentId.UserProfileChipV1?.toString():
      return <LayoutV1 navigation={navigation} />;
    case SettingLayoutComponentId.UserProfileChipV2?.toString():
      return <LayoutV2 navigation={navigation} />;
    case SettingLayoutComponentId.UserProfileChipV3?.toString():
      return <LayoutV3 navigation={navigation} />;
    case SettingLayoutComponentId.UserProfileChipV4?.toString():
      return <LayoutV4 navigation={navigation} />;
    case SettingLayoutComponentId.UserProfileChipV5?.toString():
      return <LayoutV5 />;
  }
}
